import {
  moveHamburgerToNavigationButtons,
  moveLoginToNavigationButtons,
  setHeaderTopHeightVariable,
  moveTopNavToHeader,
  setStickyHeader,
  createMenuLevel2Wrap,
  createAdditionalInfoTel,
  changeLogoMobile,
  currencySwitcher
} from "../modules/header";
import { createCarouselDots } from "../modules/carousel";
import { multiplyDiscountCoupons } from "../modules/multiplyDiscountCoupons";
import {
  createElement,
  turnTelToLink,
  splitMenu,
} from "../modules/globalFunctions";
import {
  makeFilterTitlesClickable,
  categoryHead,
  moveCategoryTop,
  changeTextInFilterBtn,
  moveBestSellers,
  bannersInCategory,
  wrapCategoryPerex,
  mergeFlags,
  moveParameterWrapper,
  wrapPtoolsandPrice,
  moveSecondDescription,
  addHideFiltersButton,
  sortingDropdown,
} from "../modules/category";
import {
  changePlaceholderDiscountCoupon,
  visibleNoteForSeller,
} from "../modules/cart";
import {
  handleProductTop,
  createAddToCartWrapper,
  handleFavoritesIcon,
  handleFlagsOnDetail,
  handleBrandOnDetail,
  handleVariantsTable,
  createShpTabLink,
  //variantsHandler,
  changeThumbnailsInDetails,
  productDetailSocialsBtnMove,
  wrapPrices,
  manipulateProductAlternatives,
  manipulateProductsRelated,
} from "../modules/productDetail";
import { blogOnHomepage, addLinkToArticles } from "../modules/blog";
import { priceStandardToPrices, couponAction } from "../modules/productCard";

import { slickSlider } from "../modules/slick.min.js";

function makeSlider(container, options = {}) {
  slickSlider();
  if (container) {
    $(container).slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      ...options,
      responsive: options.responsive || [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 926,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });
  }
}
window.language = dataLayer[0].shoptet.language;

// COMONLY USED
turnTelToLink();
createAdditionalInfoTel();
// HEADER
moveLoginToNavigationButtons();
moveHamburgerToNavigationButtons();
moveTopNavToHeader();
 currencySwitcher();
shoptet.menu.splitMenu = splitMenu;
// moveTopNavMenuToHeader()
setHeaderTopHeightVariable();
setStickyHeader();
createMenuLevel2Wrap();
changeLogoMobile();
// moveBannerToMenu()
document.addEventListener("resizeEnd", () => {
  changeLogoMobile();
});
const setColorOnAvailabilityAmount = () => {
  const availabilityAmounts = document.querySelectorAll(".availability-amount");
  if (!availabilityAmounts.length) return;
  availabilityAmounts.forEach((amount) => {
    const previousSpan = amount.previousElementSibling;
    if (previousSpan && previousSpan.hasAttribute("style")) {
      amount.setAttribute("style", previousSpan.getAttribute("style"));
    }
  });
};
setColorOnAvailabilityAmount();
document.addEventListener(
  "ShoptetDOMContentLoaded",
  setColorOnAvailabilityAmount
);

// CAROUSEL
createCarouselDots();
// END OF COMONLY USED

/*
 * This function moves the next-to-carousel-banners block to the right place and creates slick slider and heading.
 * It is used on the homepage.
 */
const handleNextToCarouselBanners = () => {
  const banners = document.querySelector(".next-to-carousel-banners");
  if (!banners) return;

  const firstProductsBlock = document.querySelector(".products-block");
  if (!firstProductsBlock) return;
  firstProductsBlock.parentElement.insertBefore(
    banners,
    firstProductsBlock.nextElementSibling
  );

  const heading = createElement(
    "div",
    ["homepage-group-title", "h4"],
    "Oblíbené kategorie"
  );
  banners.parentElement.insertBefore(heading, banners);

  const slickSettings = {
    slidesToShow: 6,
    infinite: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2.7,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  $(banners).slick(slickSettings);
};

const moveBenefitBanner = () => {
  const benefitBanner = document.querySelector(".benefitBanner");
  const benefitPlaceholder = document.querySelector("#usp-placeholder");
  if (!benefitBanner || !benefitPlaceholder) return;
  benefitPlaceholder.innerHTML = "";
  benefitPlaceholder.appendChild(benefitBanner);
};

if (dataLayer[0].shoptet.pageType === "homepage") {
  // handleNextToCarouselBanners()
  // moveBenefitBanner()
  mergeFlags();
  moveParameterWrapper();
  wrapPtoolsandPrice();
  priceStandardToPrices();
  couponAction();
}

// CATEGORY
if (dataLayer[0].shoptet.pageType === "category") {
  const moveProductCount = () => {
    const productCountWrapper = document.querySelector(
      "#category-header > div"
    );
    // const categoryHeader = document.querySelector('#category-header')
    const filtersWrapper = document.querySelector("#filters-wrapper");
    if (!productCountWrapper || !filtersWrapper) return;
    productCountWrapper.classList.add("product-count-wrapper");
    productCountWrapper.textContent = productCountWrapper.textContent.replace(
      "položek celkem",
      "produktů"
    );
    if (window.innerWidth > 767) {
      filtersWrapper.after(productCountWrapper);
    }
  };

  // handleTopProducts()
  // createCategoryWrapper()
  window.sessionStorage.setItem("openedFilters", JSON.stringify([]));

  makeFilterTitlesClickable();
  // createShowSubcategoriesButton('Ukázat více')
  // handleTotalProductCount()
  moveBestSellers();
  mergeFlags();
  priceStandardToPrices();

  bannersInCategory();
  moveParameterWrapper();
  wrapPtoolsandPrice();
  couponAction();
  moveCategoryTop();
  categoryHead();
  changeTextInFilterBtn();
  wrapCategoryPerex();

  addHideFiltersButton();
  moveSecondDescription();

  if (window.innerWidth < 768) {
    moveProductCount();
    sortingDropdown();
  }
  document.addEventListener("ShoptetDOMContentLoaded", () => {
    categoryHead();

    mergeFlags();
    moveParameterWrapper();
    wrapPtoolsandPrice();
    priceStandardToPrices();

    categoryHead();
    moveSecondDescription();
    wrapCategoryPerex();
    moveCategoryTop();
    bannersInCategory();
    // handleTopProducts()
    // createCategoryWrapper()
    addHideFiltersButton();
    makeFilterTitlesClickable();

    // Zpracování sessionStorage, pouze jeden filtr může být otevřen
    let helperCache = window.sessionStorage.getItem("openedFilters");
    if (helperCache) {
      helperCache = JSON.parse(helperCache);
      if (helperCache.length) {
        for (let item of helperCache) {
          item = item.replaceAll(" ", ".");
          item = document.querySelector(`.${item}`);
          if (item) item.classList.add("filter-form-visible");
        }
      }
    }
    moveBestSellers();

    couponAction();
    // createShowSubcategoriesButton('Ukázat více')
    // handleTotalProductCount()
    changeTextInFilterBtn();

    if (window.innerWidth < 768) {
      moveProductCount();
      sortingDropdown();
    }
  });
  document.addEventListener("resizeEnd", () => {
    breadcrumbsToPerex();
    makeBackgroundImageCategoryPerex();
    categoryHead();
  });
  // document.addEventListener('ShoptetDOMContentLoaded', makeFilterTitlesClickable)
  // document.addEventListener('ShoptetDOMContentLoaded', createShowSubcategoriesButton)
}

// PRODUCT DETAIL
if (dataLayer[0].shoptet.pageType === "productDetail") {
  handleProductTop();

  document.addEventListener("ShoptetDOMContentLoaded", handleProductTop);
  createAddToCartWrapper();
  handleFlagsOnDetail();
  handleBrandOnDetail();
  handleVariantsTable();
  manipulateProductAlternatives();
  makeSlider("#productsAlternative .products-block", {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  wrapPrices();

  wrapPtoolsandPrice();
  mergeFlags();

  document.addEventListener("DOMContentLoaded", function () {
    manipulateProductsRelated();
    productDetailSocialsBtnMove();
    changeThumbnailsInDetails();
   
  });

  document.addEventListener("shoptet.modal.open", () => {
    setTimeout(() => {
      manipulateProductsRelated();
    }, 250);
  });
  document.addEventListener("ShoptetDOMContentLoaded", () => {
    wrapPtoolsandPrice();
    mergeFlags();
  });
  // adds a banner to a list of special products. The list is an array of product codes in editor decided by client
  const addBannerToSpecialProducts = () => {
    if (typeof produktySBannerem === "undefined" || !produktySBannerem.length)
      return;
    const productCode = dataLayer[0].shoptet.product.code;

    const specialBannerSpan = document.querySelector(
      "footer .banner .special-banner"
    );
    if (!specialBannerSpan) return;
    const specialBanner = specialBannerSpan.closest(".banner-wrapper");
    if (specialBanner) {
      const parent = specialBanner.closest(".banner").parentElement;
      if (parent) parent.remove();
    }
    if (!productCode) return;
    // check if productCode is in the array produktySBannerem
    if (produktySBannerem.find((product) => product == productCode)) {
      //add banner to product detail
      const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
      const pInfoWrapper = document.querySelector(".p-info-wrapper");
      if (addToCartWrapper) {
        addToCartWrapper.before(specialBanner);
      } else if (pInfoWrapper) {
        pInfoWrapper.appendChild(specialBanner);
      }
    }
  };
  addBannerToSpecialProducts();

  let detailParametersVariants = document.querySelectorAll(
    ".detail-parameters td > select"
  );
  if (detailParametersVariants.length) {
    detailParametersVariants.forEach((variant) => {
      if (variant.hasAttribute("data-parameter-id")) {
        let variantId = variant.getAttribute("data-parameter-id");
        if (variantId) {
          // variantsHandler(variantId);
        }
      }
    });
  }

  const extendedDescription = document.querySelector(".extended-description");
  if (extendedDescription) {
    extendedDescription.id = "parameters";

    const shpTabParameters = createShpTabLink(
      window.language == "cs" ? "Parametry" : "Parametre",
      "#parameters"
    );
    const detailTabs = document.querySelector(".p-detail-tabs");
    if (detailTabs) detailTabs.firstElementChild.after(shpTabParameters);
  }

  // const pMainImage = document.querySelector('.p-main-image')
  // const pImageWrapper = document.querySelector('.p-image-wrapper')
  // const thumbnailsWrapper = document.querySelector('.p-thumbnails-wrapper')
  // if (pMainImage) {
  // 	const clickToZoom = createElement(
  // 		'div',
  // 		['click-to-zoom'],
  // 		window.language == 'cs' ? 'Kliknutím zvětšíte obrázek' : 'Kliknutím zväčšíte obrázok'
  // 	)
  // 	// if (window.innerWidth > 767) {
  // 	if (thumbnailsWrapper) clickToZoom.classList.add('with-thumbnails')
  // 	pMainImage.appendChild(clickToZoom)
  // 	// } else if (pImageWrapper) pImageWrapper.appendChild(clickToZoom)
  // }
  // const variantsAvailabilitySpans = document.querySelectorAll('.p-info-wrapper .parameter-dependent .availability-label')
  // const availability = document.querySelector('.p-info-wrapper .availability-label')

  // if (variantsAvailabilitySpans.length) {
  // 	for (const span of variantsAvailabilitySpans) {
  // 		span.parentElement.style.backgroundColor = span.style.color
  // 		span.style.color = '#2F3138'
  // 	}
  // } else if (availability) availability.style.backgroundColor = availability.style.color

  document.addEventListener(
    "dkLabFavouriteProductsLoaded",
    handleFavoritesIcon
  );
} else {
  const specialBannerSpan = document.querySelector(
    "footer .banner .special-banner"
  );
  if (specialBannerSpan) {
    const specialBannerParent =
      specialBannerSpan.closest(".banner").parentElement;
    if (specialBannerParent) {
      specialBannerParent.remove();
    }
  }
}

// BLOG
if (document.body.classList.contains("type-posts-listing")) {
  addLinkToArticles();
}

const carouselItems = document.querySelectorAll(".item");

carouselItems.forEach((item) => {
  const promoLinks = item.querySelector("a[data-ec-promo-id]");

  if (promoLinks) {
    const div = document.createElement("div");

    Array.from(promoLinks.attributes).forEach((attr) => {
      if (attr.name !== "href") {
        div.setAttribute(attr.name, attr.value);
      }
    });

    div.innerHTML = promoLinks.innerHTML;

    promoLinks.parentNode.replaceChild(div, promoLinks);
  }

  const accButtons = item.querySelector(".acc-buttons");
  const extendedBannerText = item.querySelector(".extended-banner-text");

  if (accButtons && extendedBannerText) {
    extendedBannerText.appendChild(accButtons);
    const promoLinksInButtons = accButtons.querySelectorAll(
      "a[data-ec-promo-id]"
    );
    promoLinksInButtons.forEach((link) => link.remove());
  }
});
function addLinkToProductBlockHeader() {
  if (document.body.classList.contains("in-index")) {
    const titleElements = document.querySelectorAll(".homepage-group-title.h4");

    titleElements.forEach((element) => {
      const text = element.textContent.trim();

      if (text.includes("#")) {
        const parts = text.split("#");
        const mainText = parts[0].trim();
        const hashtagText = parts[1].trim();

        const link = document.createElement("a");
        link.classList.add("hashtag-link", "btn", "btn-primary");
        link.href = `/${hashtagText}/`;
        link.textContent = "Všechny produkty";

        element.textContent = mainText;
        element.appendChild(link);
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", addLinkToProductBlockHeader);

function hpProductsWrapper() {
  if (!document.body.classList.contains("in-index")) return;

  if (!pairingBanners) return;

  const productsBlocks = document.querySelectorAll(".products-block");
  if (!productsBlocks.length) return;

  productsBlocks.forEach((productsBlock) => {
    const productsBlockId = productsBlock.getAttribute("id");
    const productsBlockHeader = productsBlock.previousElementSibling;

    if (
      !productsBlockHeader ||
      !productsBlockHeader.classList.contains("homepage-group-title")
    )
      return;

    const productsWrapper = document.createElement("div");
    productsWrapper.classList.add(productsBlockId + "-wrapper", "products-box");
    if (productsBlockHeader.textContent.includes("#GR#")) {
      productsWrapper.classList.add("products-box-gr");
      productsBlockHeader.textContent = productsBlockHeader.textContent.replace(
        "#GR#",
        ""
      );
    }

    const productsAndBanner = document.createElement("div");
    productsAndBanner.classList.add("products-and-banner");
    productsAndBanner.setAttribute("id", "wrap-" + productsBlockId);
    productsBlockHeader.parentNode.insertBefore(
      productsAndBanner,
      productsBlockHeader
    );

    productsWrapper.appendChild(productsBlock);

    const bannerClass = pairingBanners[productsBlockId];
    let banner = null;
    if (bannerClass) {
      banner = document.querySelector(`.${bannerClass}`);
      banner.classList.add("footer--banner");
    }

    if (banner) {
      productsAndBanner.appendChild(productsBlockHeader);

      productsAndBanner.appendChild(productsWrapper);
      productsWrapper.prepend(banner);
    } else {
      productsWrapper.appendChild(productsBlockHeader);
      productsAndBanner.appendChild(productsWrapper);
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  hpProductsWrapper();
});

if (document.body.classList.contains("in-index")) {
  blogOnHomepage();
  addLinkToArticles();
}
function buttonToProductsArrows() {
  const productsBx = document.querySelectorAll(".products-box");

  setTimeout(() => {
    productsBx.forEach((elm) => {
      const productsBlock = elm.querySelector(".products-block");
      const continueButton = elm.querySelector(".products-box .hashtag-link");
      const slickDots = elm.querySelector(".slick-dots");
      if (!slickDots && !continueButton) return;
      const dotsPlusBtn = document.createElement("div");
      dotsPlusBtn.classList.add("slick-dots-plus-btn");
      dotsPlusBtn.appendChild(slickDots);
      dotsPlusBtn.appendChild(continueButton);
      productsBlock.appendChild(dotsPlusBtn);
    });
  }, 250);
}
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 1199) {
    buttonToProductsArrows();
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 768) {
    const itemsToShow = 2;
    const ambasadors = Array.from(
      document.querySelectorAll(".ambasadors-list .ambasador")
    );
    if (!ambasadors.length) return;
    // Skryj všechny
    ambasadors.forEach((item) => (item.style.display = "none"));

    // Zobraz prvních X
    ambasadors
      .slice(0, itemsToShow)
      .forEach((item) => (item.style.display = ""));

    // Vytvoř tlačítko
    const loadMoreBtn = document.createElement("button");
    loadMoreBtn.textContent = "Načíst další";
    loadMoreBtn.className = "load-more";
    document.querySelector(".ambasadors-list").after(loadMoreBtn);

    loadMoreBtn.addEventListener("click", function () {
      const currentlyVisible = ambasadors.filter(
        (item) => item.style.display !== "none"
      ).length;
      const nextItems = ambasadors.slice(
        currentlyVisible,
        currentlyVisible + itemsToShow
      );

      nextItems.forEach((item) => {
        item.style.display = "";
      });

      if (currentlyVisible + itemsToShow >= ambasadors.length) {
        loadMoreBtn.remove();
      }
    });
    document
      .querySelectorAll(".ambasadors-list .ambasador, .main-ambasador")
      .forEach((ambasador) => {
        const paragraphs = ambasador.querySelectorAll(".text p");

        if (paragraphs.length > 1) {
          for (let i = 1; i < paragraphs.length; i++) {
            paragraphs[i].style.display = "none";
          }

          const readMoreBtn = document.createElement("a");
          readMoreBtn.href = "#";
          readMoreBtn.textContent = "Číst více";
          readMoreBtn.className = "read-more";
          paragraphs[0].after(readMoreBtn);

          readMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();

            for (let i = 1; i < paragraphs.length; i++) {
              paragraphs[i].style.display = "";
            }

            readMoreBtn.remove();
          });
        }
      });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("id--9")) {
    changePlaceholderDiscountCoupon();
    multiplyDiscountCoupons();
  }
  if (document.body.classList.contains("id--17")) {
    visibleNoteForSeller();
  }
});
document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  if (document.body.classList.contains("id--9")) {
    multiplyDiscountCoupons();
  }
});
const filtersUnveil = document.querySelector(
  ".filters-unveil-button-wrapper .unveil-button"
);
const filtersHide = document.querySelector("#filters .btn-primary");
if (filtersUnveil) {
  filtersUnveil.addEventListener("click", () => {
    window.sessionStorage.setItem("filtersState", "unveiled");
  });
}
if (filtersHide) {
  filtersHide.addEventListener("click", () => {
    window.sessionStorage.setItem("filtersState", "hidden");
  });
}
if (window.sessionStorage.getItem("filtersState") === "unveiled") {
  const filters = document.getElementById("filters");
  if (filters) filters.classList.add("visible");
}
document.addEventListener("ShoptetDOMContentLoaded", () => {
  const filtersHide = document.querySelector("#filters .btn-primary");
  if (filtersHide) {
    filtersHide.addEventListener("click", () => {
      window.sessionStorage.setItem("filtersState", "hidden");
    });
  }
  const filters = document.getElementById("filters");
  if (window.sessionStorage.getItem("filtersState") === "unveiled") {
    const filters = document.getElementById("filters");
    if (filters) filters.classList.add("visible");
  }
});
